import { cubicBezier } from "./cubic-bezier.js";
import { mirrorEasing } from "./modifiers/mirror.js";
import { reverseEasing } from "./modifiers/reverse.js";
const backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = reverseEasing(backOut);
const backInOut = mirrorEasing(backIn);
export {
  backIn,
  backInOut,
  backOut
};
//# sourceMappingURL=back.js.map
